import { useQuery } from 'react-query';
import { SearchQueryResponse } from 'v2/models';
import restFactory from 'v2/utils/restFactory';

export function getKey(searchId: number) {
  return ['Get specific request by ID', searchId];
}

export function useSearchDetails(searchId: number) {
  return useQuery(
    getKey(searchId),
    async () => {
      const response = await restFactory.get<SearchQueryResponse>(
        `/dj/api/v1/search/details/`,
        { id: searchId }
      );
      return response.results[0];
    },
    { cacheTime: 0 }
  );
}
